<template>
  <Form as="div" ref="form">
    <div class="grid-y container">
      <page-overlay :show="data && data.length < 1">
        <template>
          <div class="modal">
            <message-box v-if="messageBox" :input="messageBox" />
          </div>
        </template>
      </page-overlay>
      <page-spinner :spinner-url-list="spinnerUrlList" />
      <h2 class="cell" data-test="subtitle2" v-html="texts.subtitle2" />
      <div data-test="table" class="cell border">
        <div class="headline grid-x background">
          <div @click="toggel($event)">
            <tick-checkbox v-model="all" name="all" data-test="checkbox-all" class="cell shrink grid-y align-center start" />
          </div>
          <div
            class="auto cell grid-y align-center hide-for-large"
            data-test-headline-element="PolicyTypeShortText"
            v-text="headline.PolicyTypeShortText"
          />
          <div
            class="auto cell grid-y align-center show-for-large"
            data-test-headline-element="PolicyTypeText"
            v-text="headline.PolicyTypeText"
          />
          <div
            class="auto cell grid-y align-center show-for-large"
            data-test-headline-element="HolderText"
            v-text="headline.HolderText"
          />
          <div
            class="auto cell grid-y align-center show-for-large"
            data-test-headline-element="PaymentFrequencyText"
            v-text="headline.PaymentFrequencyText"
          />
          <div
            class="auto cell grid-y align-center show-for-large"
            data-test-headline-element="NextPaymentText"
            v-text="headline.NextPaymentText"
          />
          <div
            class="auto cell grid-y align-center show-for-large"
            data-test-headline-element="PeriodText"
            v-text="headline.PeriodText"
          />
          <div
            class="auto cell grid-y align-center t-right"
            data-test-headline-element="FeeText"
            v-text="headline.FeeText"
          />
        </div>
        <div v-for="(line, linenr) in data" :key="linenr" class="cell body grid-x" :data-test-insurance-line="linenr">
          <tick-checkbox
            v-model="chosenLines[linenr]"
            :name="'check' + linenr"
            :data-test="'checkbox-line-' + linenr"
            class="shrink cell grid-y align-center start"
          />

          <div class="auto cell grid-y align-center" :data-test-insurance-line-element="'line-' + linenr + '-Policy'">
            <div :data-test-policy-type="linenr" v-html="line.PolicyType" />
            <div v-if="line.Number" class="gray-html" :data-test-number="linenr" v-html="line.Number" />
          </div>
          <div
            class="auto cell grid-y align-center show-for-large"
            :data-test-insurance-line-element="'line-' + linenr + '-Holder'"
          >
            <div :data-test-holder="linenr" v-html="line.Holder" />
          </div>
          <div
            class="auto cell grid-y align-center show-for-large"
            :data-test-insurance-line-element="'line-' + linenr + '-PaymentFrequency'"
          >
            <div :data-test-payment-frequency="linenr" v-html="line.PaymentFrequency" />
          </div>
          <div
            class="auto cell grid-y align-center show-for-large"
            :data-test-insurance-line-element="'line-' + linenr + '-NextPayment'"
          >
            <div :data-test-next-payment="linenr" v-html="line.NextPayment" />
          </div>
          <div
            class="auto cell grid-y align-center show-for-large"
            :data-test-insurance-line-element="'line-' + linenr + '-Period'"
          >
            <div class="dash" :data-test-start-date="linenr" v-html="line.StartDate" />
            <div :data-test-end-date="linenr" v-html="line.EndDate" />
          </div>
          <div class="auto cell grid-y align-center t-right" :data-test-insurance-line-element="'line-' + linenr + '-Fee'">
            <div :data-test-fee="linenr" v-html="line.SavingsString" />
          </div>
        </div>
      </div>
      <div>
        <Field v-model="anyChecks" type="hidden" name="anyChecks" v-slot="{ field }" :rules="'anyChecks'">
          <input v-bind="field" type="hidden" />
        </Field>
        <ValidationError name="anyChecks" data-test="any-checks" />
      </div>
      <div class="cell big-text" data-test="savings" v-html="textsSavings" />
      <div class="cell" data-test="fee" v-html="texts.fee" />
      <div class="note">
        <strong class="bold" v-html="texts.noteTitle" />
        <span v-html="texts.note" />
      </div>
      <div class="cell grid-x">
        <betalings-service v-model="accountDetails" class="bs cell small-12 medium-8 large-3" />
      </div>
      <div class="cell grid-x">
        <button
          class="cell meduim-12 large-3 button text-center"
          data-test="bs-button"
          @click="addBS()"
          v-html="texts.button"
        />
      </div>
      <tag-manager />
    </div>
  </Form>
</template>
<script>
import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';
import BaseMixinVue from '@/components/Feature/BaseMixin.vue';
import BetalingsService from '@/components/UI/BetalingsService.vue';
import PageSpinner from '@/components/UI/PageSpinner.vue';
import TagManager from '@/components/UI/TagManager.vue';
import TickCheckbox from '@/components/Forms/TickCheckbox.vue';
import PageOverlay from '@/components/UI/PageOverlay.vue';
import MessageBox from '@/components/UI/MessageBox.vue';
import MessageBoxObject from '@/components/Objects/MessageBox';
import LinkModel from '@/components/Objects/LinkModel';
import { defineRule } from 'vee-validate';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  name: 'BetalingsServiceTilmelding',
  components: {
    BetalingsService,
    TickCheckbox,
    TagManager,
    PageSpinner,
    PageOverlay,
    MessageBox,
    ValidationError
  },
  mixins: [BaseMixinVue],
  props: {
    viewModel: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      all: false,
      accountDetails: {
        accountNumber: null,
        registrationNumber: null
      },
      loaded: false,
      chosenLines: [],
      texts: {
        subtitle2: 'Vælg den eller de forsikringer, du vil tilmelde Betalingsservice, og se hvor meget du kan spare',
        savings: 'Din besparelse i alt: {{savings}} kr. om året',
        fee: 'Du betaler kun 6 kr. i gebyr per betaling.',
        button: 'Tilmeld Betalingsservice',
        noteTitle: 'Bemærk: ',
        note: 'Du skal bruge din egen bankkonto, når du tilmelder.',
        checks: 'Vælge mindst en police.',
        messageBoxTitle: 'Du har ikke forsikringer, der kan tilmeldes Betalingsservice',
        messageBoxText: `På Min Side kan du under hver af dine forsikringer se hvilken betalingsmetode, du har valgt.
Kontakt os, hvis du har spørgsmål eller brug for hjælp.
`,
        messageBoxButtonLink: null
      },
      data: undefined,
      headline: {
        PolicyTypeText: 'Din forsikring(er)',
        PolicyTypeShortText: 'Forsikring',
        HolderText: 'Hvad/Hvem',
        PaymentFrequencyText: 'Betalingstermin',
        NextPaymentText: 'Næste betaling',
        PeriodText: 'Forsikringsperiode',
        FeeText: 'Besparelse'
      },
      check: false,
      spinnerUrlList: [Utility.constants().API.policieswithoutpaymentagreementPost]
    };
  },
  computed: {
    disabled() {
      return this.chosenLines.find((e) => e === true) === undefined;
    },
    textsSavings() {
      return this.texts.savings.replace('{{savings}}', this.savings);
    },
    savings() {
      if (this.data) {
        return this.data
          .filter((_, index) => this.chosenLines[index])
          .map((x) => x.Savings)
          .reduce((a, b) => a + b, 0);
      }
      return 0;
    },
    anyChecks: {
      get() {
        return this.chosenLines.filter((el) => el).length > 0;
      },
      set(val) {
        this.chosenLines = Array.from(this.data, () => val);
      }
    },
    messageBox() {
      if (this.texts.messageBoxButtonLink) {
        return new MessageBoxObject(
          this.texts.messageBoxTitle,
          this.texts.messageBoxText,
          new LinkModel(this.texts.messageBoxButtonLink)
        );
      }
      return null;
    }
  },
  watch: {
    chosenLines() {
      if (this.chosenLines.every((v) => v)) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  created() {
    defineRule('anyChecks', (value) => {
      if (!value) return this.texts.checks;
      return true;
    });
  },
  mounted() {
    if (this.viewModel) {
      Object.keys(this.viewModel).forEach((key) => {
        const localKey = key.slice(0, 1).toLowerCase() + key.slice(1);
        this.texts[localKey] = this.viewModel[key];
      });
    }
    this.getData();
  },
  methods: {
    getData() {
      const vm = this;
      axios
        .get(Utility.constants().API.policieswithoutpaymentagreement)
        .then((response) => {
          this.data = response.data;
          this.chosenLines = Array.from(this.data, () => true);
        })
        .catch(() => {})
        .finally(() => {
          vm.loaded = true;
        });
    },
    toggel($event) {
      if (this.data) {
        this.all = !this.all;
        this.chosenLines = Array.from(this.data, () => this.all);
      }
      $event.preventDefault();
    },
    addBS() {
      const vm = this;
      vm.$refs.form.validate().then((resultObj) => {
        if (resultObj.valid) {
          vm.postData();
        }
      });
    },
    postData() {
      const vm = this;
      const postData = [];

      vm.data
        .filter((el, index) => this.chosenLines[index])
        .forEach((element) => {
          postData.push({
            AccountNumber: this.accountDetails.accountNumber,
            RegistrationNumber: this.accountDetails.registrationNumber,
            PolicyNumber: element.Number
          });
        });
      axios
        .post(Utility.constants().API.policieswithoutpaymentagreementPost, postData)
        .then(() => {
          this.$store.dispatch('Events/register', {
            id: 'bs',
            event: 'bs-landing-page-button'
          });
          window.location.assign('/tilmeld-bs/kvittering');
        })
        .catch((err) => {
          Utility.logError(err, this);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/all.scss';
$margin: 23px;

@mixin cell {
  .cell {
    min-height: rem-calc(50px);
    padding-top: rem-calc(10px);
    padding-bottom: rem-calc(10px);
  }
}

h2 {
  margin-bottom: rem-calc($margin);
}

.big-text {
  font-weight: bold;
  font-size: rem-calc(18px);
  line-height: rem-calc(25px);
  margin-bottom: rem-calc(5px);
}

.border {
  border-radius: 3px;
  border: 1px solid $formfield-border;
  margin-bottom: rem-calc($margin);
}

.background {
  background-color: $light-gray;

  @include cell;
}

.body {
  @include cell;
}

.bs {
  margin: rem-calc($margin) 0;
}

.gray-text {
  color: $input-placeholder-color;
}

.dash::after {
  content: ' -';
}

.container {
  @include breakpoint(medium up) {
    margin-bottom: rem-calc(60px);
  }
}

.start {
  @include breakpoint(medium up) {
    padding-left: rem-calc(20px);
  }
  @include breakpoint(small only) {
    padding-left: rem-calc(10px);
  }
}

.t-right {
  @include breakpoint(small only) {
    text-align: right;
    padding-right: rem-calc(9px);
  }
}

.bold {
  font-weight: bold;
}

.note {
  margin: rem-calc($margin) 0 0 0;
}

.message {
  width: auto;
  max-width: 500px;
  max-height: 100vh;
  margin: 120px auto 20px;
  background-color: #f2f2f2;
  border: 0px solid #cacaca;
  border-radius: 1.3333333333rem;
}
</style>
../../../Objects/MessageBox../../../Objects/LinkModel ../Forms/TickCheckbox.vue
